import { IconButton, PaletteColor, Theme, styled } from '@mui/material';

export type IconButtonVariant = 'default' | 'contained';

type PaletteKeys = keyof Pick<
	Theme['palette'],
	{
		[K in keyof Theme['palette']]: Theme['palette'][K] extends PaletteColor ? K : never;
	}[keyof Theme['palette']]
>;

const isThemeColor = (theme: Theme, color?: string): color is PaletteKeys => {
	if (!color) return false;
	return Boolean(
		color in theme.palette &&
			theme.palette[color as keyof Theme['palette']] &&
			'main' in (theme.palette[color as keyof Theme['palette']] as object),
	);
};

export const StyledIconButton = styled(IconButton, {
	shouldForwardProp: (prop: string) => !['variant', 'background'].includes(prop),
})<{ variant: IconButtonVariant; background: string }>(({ theme, color, variant, background }) => {
	const isThemeColorApplied = isThemeColor(theme, color);
	const buttonColor = isThemeColorApplied ? theme.palette[color].contrastText : color;
	const buttonBackground = isThemeColorApplied ? theme.palette[color].main : color;
	const hoverBackground = isThemeColorApplied ? theme.palette[color].dark : 'rgba(0, 0, 0, 0.04)';

	return {
		borderRadius: variant === 'contained' ? '8px' : '50%',
		color: buttonColor,
		...(variant === 'contained' && {
			background: background || buttonBackground,
			'&:hover': {
				background: hoverBackground,
			},
		}),
		...(variant !== 'contained' && {
			...(background && { background }),
			'&:hover': {
				background: 'rgba(0, 0, 0, 0.04)',
			},
		}),
	};
});
